import { render, staticRenderFns } from "./CambiarPalabraSecreta.vue?vue&type=template&id=08f5dc57&scoped=true&"
import script from "./CambiarPalabraSecreta.vue?vue&type=script&lang=js&"
export * from "./CambiarPalabraSecreta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5dc57",
  null
  
)

export default component.exports